import i18n from 'i18next';
import { PaymentOptionPropertiesInterface } from './Interfaces';

const TranslationPath = 'Services:Exports:Constants';

export const AVAILABLE_LANGUAGES = [
  {
    language: 'de',
    languageName: 'German',
  },
  {
    language: 'en',
    languageName: 'English',
  },
];

export enum OTP_DELIVERY_CHANNELS {
  SMS = 'sms',
  EMAIL = 'email',
}

export enum ORDERS_PAUSED_REASON {
  MANUAL = 'manual',
  INACTIVITY = 'inactivity',
}

export enum EventHelperTypes {
  LOG_OUT = 'log_out',
  DISPLAY_INFO_MODAL = 'display_info_modal',
  SHOW_MENU_ITEMS_MODAL = 'show_menu_modal',
  TOGGLE_PAYMENT_METHOD = 'toggle_payment_method',
  NO_INTERNET = 'no_internet',
}

export enum COUPON_TYPES {
  REWARD = 1,
  CASHBACK = 2,
  PROMO_CODE = 3,
}

export enum PROMO_CODE_DISCOUNT_TYPES {
  FIXED_AMOUNT = 'fixed_amount',
  PERCENTAGE = 'percentage',
}

export enum ORDER_METHODS {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
  DINE_IN = 'dine_in',
  ROOM_SERVICE = 'room_service',
}

export enum ORDER_PAYMENT_STATUSES {
  PENDING = 'pending',
  PAID = 'paid',
  PARTIALLY_REFUNDED = 'partially_refunded',
  REFUNDED = 'refunded',
}

export enum ORDER_FULFILLMENT_STATUSES {
  CREATED = 'created',
  REVIEWED = 'reviewed',
  ACCEPTED = 'accepted',
  PREPARING = 'preparing',
  READY = 'ready',
  ON_DELIVERY = 'on_delivery',
  PICKED = 'picked',
  REJECTED = 'rejected',
}

export enum SCREENS {
  NOT_FOUND_SCREEN = '404',
  HOME_SCREEN = '/',
  CHECKOUT = 'checkout',
  BASKET = 'basket',
  ORDER_DETAILS = 'order-details',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIE_POLICY = 'cookie-policy',
  IMPRESSUM = 'impressum',
  UPLOAD_GOOGLE_REVIEW_SCREEN = 'upload-google-review',
  REWARD_DETAILS_SCREEN = 'reward-details',
}

export enum PaymentMethod {
  Cash = 'cash',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  PaypalStandalone = 'paypal_standalone',
  Card = 'card',
  Paypal = 'paypal',
  Sofort = 'sofort',
  Giropay = 'giropay',
  SepaDebit = 'sepa_debit',
  BacsDebit = 'bacs_debit',
}

export enum PaymentMethodBrand {
  Visa = 'visa',
  MasterCard = 'master_card',
  AmericanExpress = 'american_express',
}

export const PAYMENT_METHODS = (): PaymentOptionPropertiesInterface[] => [
  {
    id: 1,
    payment_method_id: PaymentMethod.Card,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'Credit Card',
    display_name: i18n.t(TranslationPath + '.payment_methods.card'),
    is_default: false,
    is_saved: false,
  },
  {
    id: 3,
    payment_method_id: PaymentMethod.ApplePay,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'Apple Pay',
    display_name: 'Apple Pay',
    is_default: false,
    is_saved: false,
  },
  {
    id: 4,
    payment_method_id: PaymentMethod.GooglePay,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'Google Pay',
    display_name: 'Google Pay',
    is_default: false,
    is_saved: false,
  },
  {
    id: 6,
    payment_method_id: PaymentMethod.Giropay,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'Giro Pay',
    display_name: i18n.t(TranslationPath + '.payment_methods.giropay'),
    is_default: false,
    is_saved: false,
  },
  {
    id: 5,
    payment_method_id: PaymentMethod.Sofort,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'Sofort',
    display_name: i18n.t(TranslationPath + '.payment_methods.sofort'),
    is_default: false,
    is_saved: false,
  },
  {
    id: 2,
    payment_method_id: PaymentMethod.Paypal,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'PayPal',
    display_name: 'PayPal',
    is_default: false,
    is_saved: false,
  },
  // {
  //   id: 7,
  //   payment_method_id: PaymentMethod.SepaDebit,
  //   payment_method_brand: null,
  //   payment_method_details: null,
  //   name: "Sepa Debit",
  //   display_name: i18n.t(TranslationPath + ".payment_methods.iban"),
  //   is_default: false,
  //   is_saved: false,
  // },
  {
    id: 8,
    payment_method_id: PaymentMethod.Cash,
    external_payment_method_id: null,
    payment_method_brand: null,
    payment_method_details: null,
    name: 'Cash',
    display_name: i18n.t(TranslationPath + '.payment_methods.cash'),
    is_default: false,
    is_saved: false,
  },
];

export enum PROMO_CODE_TYPES {
  ONE_TIME_PROMO_CODE = 'single_use',
  MULTI_PROMO_CODE = 'multi_use',
}

export enum PUSHER_EVENTS {
  ORDER_UPDATED = 'order.updated',
  ORDER_PAID = 'order.paid',
  ORDER_FAILED = 'order.failed',
  TRANSACTION_PAID = 'transaction.paid',
  REFUND_CREATED = 'refund.created',
  ORDERS_PAUSED = 'orders.paused',
  ORDERS_UNPAUSED = 'orders.unpaused',
}

export enum SCREEN_TYPES {
  DESKTOP = 'Desktop',
  TABLET = 'Tablet',
  MOBILE = 'Mobile',
}

export enum APP_STATE_REDUCER_TYPES {
  TOGGLE_LOGIN_MODAL = 'toggle_login_modal',
  TOGGLE_INFO_MODAL = 'toggle_info_modal',
  TOGGLE_MENU_ITEM_MODAL = 'toggle_menu_item_modal',
  SAVE_MENU = 'save_menu',
  TOGGLE_ORDER_METHOD_MODAL = 'toggle_order_method_modal',
  TOGGLE_OTP_VERIFICATION_MODAL = 'toggle_otp_verification_modal',
  TOGGLE_FREE_PRODUCTS_MODAL = 'toggle_free_products_modal',
  TOGGLE_RESTAURANT_CLOSED_MODAL = 'toggle_restaurant_closed_modal',
  TOGGLE_ORDER_BASKET_MODAL = 'toggle_order_basket_modal',
  TOGGLE_ELIGIBLE_OFFERS_MODAL = 'toggle_eligible_offers_modal',
  TOGGLE_OFFER_MODAL = 'toggle_offer_modal',
  TOGGLE_FREE_ITEMS_MODAL = 'toggle_free_items_modal',
  TOGGLE_MOBILE_APP_SIGNUP_BONUS_MODAL = 'toggle_mobile_app_signup_bonus_modal',
}

export enum MODAL_SIZES {
  XS = 'lg:w-[540px] w-screen mx-md',
  SM = 'lg:w-[640px] w-screen mx-md',
  MD = 'lg:w-[740px] w-screen mx-md',
  LG = 'lg:w-[840px] w-screen mx-md',
  XL = 'lg:w-5/6 w-screen mx-md',
}

export enum ERROR_CODES {
  OTP_VERIFICATION_REQUIRED = 'otp_check_required',
  ACCOUNT_SWITCH_REQUIRED = 'account_switch_required',
  ORDER_TIME_NOT_AVAILABLE = 'order_time_not_available',
  ORDERS_PAUSED = 'orders_paused',
  COMPANY_CLOSED = 'company_closed',
  PICKUP_CLOSED = 'pickup_closed',
  DELIVERY_CLOSED = 'delivery_closed',
  DELIVERY_UNAVAILABLE = 'delivery_unavailable',
  ITEMS_OUT_OF_STOCK = 'items_out_of_stock',
  PROMO_CODE_INVALID = 'promo_code_invalid',
  PROMO_CODE_THRESHOLD_NOT_REACHED = 'promo_code_usage_threshold_not_reached',
  ADDRESS_OUTSIDE_DELIVERY_ZONE = 'address_outside_delivery_zone',
  NO_DELIVERY_QUOTES_AVAILABLE = 'no_delivery_quotes_available',
  ADDRESS_NOT_FOUND = 'address_not_found',
  DELIVERY_QUOTE_ALREADY_USED = 'delivery_quote_already_used',
  CARD_EXCEPTION = 'card_exception',
  ORDER_FULFILLMENT_FAILED = 'order_fulfillment_failed',
  CASH_PAYMENTS_NOT_SUPPORTED = 'cash_payments_not_supported',
  ITEMS_MENU_TIME_UNAVAILABLE = 'items_menu_time_unavailable',
  ROOM_SERVICE_LOCATION_UNAVAILABLE = 'room_service_location_unavailable',
  ROOM_SERVICE_UNAVAILABLE = 'room_service_unavailable',
}

export enum PUSHER_CONNECTION_STATES {
  INITIALIZED = 'initialized',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  UNAVAILABLE = 'unavailable',
  FAILED = 'failed',
  DISCONNECTED = 'disconnected',
}

export enum GOOGLE_REVIEW_STATUS_TYPES {
  UNDETERMINED = 0,
  IN_REVIEW = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum ENVIRONMENTS {
  DEV = 'Development',
  STAGING = 'Staging',
  PROD = 'Production',
}

export enum REDUX_STORE_SLICES {
  APP_STATUS = 'appStatus',
  EVENT_HELPER = 'eventHelper',
  INITIAL_DATA = 'initialData',
  BASKET = 'basket',
  OFFER = 'offer',
  ORDER = 'order',
  PROFILE = 'profile',
  PAYMENT_FLOW = 'paymentFlow',
  PAYMENT_OPTIONS = 'paymentOptions',
  PRODUCT_LIKES = 'productLikes',
  MODAL = 'modal',
  ORDER_METHOD = 'order_method',
  MARKETING = 'marketing',
  MOBILE_APP = 'mobileApp',
}

export enum DELIVERY_ZONE_GEOMETRY_TYPES {
  CIRCLE = 'circle',
  POLYGON = 'polygon',
  ZIP = 'zip',
}

export const ORDER_PRODUCT_HEIGHT = 130;

export enum PRODUCT_IDENTIFIERS {
  VEGAN = 'vgn',
  VEGETARIAN = 'vgt',
  GLUTEN_FREE = 'gf',
  DAIRY_FREE = 'df',
  HALAL = 'hal',
  SPICY = 'h&s',
}

export enum EntryType {
  Product = 'product',
  Modifier = 'modifier',
}

export enum ModifierGroupType {
  SystemUpsell = 4,
}

export enum CategoryType {
  Default = 'default',
  Favourites = 'favourites',
  FreeItems = 'free_items',
  MostPopular = 'most_popular',
  Bogo = 'bogo',
}

export enum TaxBehaviour {
  Inclusive = 'inclusive',
  Exclusive = 'exclusive',
}

export enum RoomServiceLocationType {
  RoomService = 'room_service',
  TableService = 'table_service',
}

export enum SmartPricingRuleModifierType {
  Absolute = 'absolute',
  FixedValue = 'fixed_value',
  Percentage = 'percentage',
}

export enum DEAL_TYPES {
  GOOGLE_REVIEW_PROGRAM = 'google_review_program',
  SMART_PRICING_RULE = 'smart_pricing_rule',
}

export enum OfferKindEnum {
  PercentageOffByProducts = 'percentage_off_by_products',
  PercentageOffByMinSpendValue = 'percentage_off_by_min_spend_value',
  AmountOffByProducts = 'amount_off_by_products',
  AmountOffByMinSpendValue = 'amount_off_by_min_spend_value',
  Bogo = 'bogo',
  BogoHalfPrice = 'bogo_half_price',
  FreeItemByProducts = 'free_item_by_products',
  FreeItemByMinSpendValue = 'free_item_by_min_spend_value',
}

export enum OfferTypeEnum {
  Bogo = 'bogo',
  PercentageOff = 'percentage_off',
  AmountOff = 'amount_off',
  FreeItem = 'free_item',
}

export enum DeliveryMode {
  Internal = 'internal',
  External = 'external',
}

export enum DeliveryProvider {
  Standalone = 'standalone',
  FirstDelivery = 'first_delivery',
  WoltDrive = 'wolt_drive',
}

export enum DeliveryCarrier {
  Uber = 'uber',
  Wolt = 'wolt',
}

export enum DeliveryStatus {
  Pending = 'pending',
  RunnerAssigned = 'runner_assigned',
  OnRoutePickup = 'en_route_pickup',
  ArrivedPickup = 'arrived_pickup',
  PickedUp = 'picked_up',
  OnRouteDropoff = 'en_route_dropoff',
  ArrivedDropoff = 'arrived_dropoff',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum DropoffAction {
  RingDoorBell = 'ring_door_bell',
  Sms = 'sms',
}

export enum AuthGrant {
  OneTimePassword = 'one_time_password',
  NhasUserToken = 'nhas_user_token',
}

export enum AppWebViewMessageTypes {
  PaymentIntent = 'payment_intent',
  LoadStripe = 'load_stripe',
  AuthToken = 'auth_token',
  RequestPushNotification = 'request_push_notification',
  RequestAppRating = 'request_app_rating',
}

export enum OnlineShopWebViewMessageTypes {
  PaymentResult = 'payment_result',
  SetPushNotificationRequestStatus = 'set_push_notification_request_status',
  OpenModal = 'open_modal',
  Navigate = 'navigate',
  AppReviewRequested = 'app_review_requested',
}

export enum PaymentStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export enum DeviceOS {
  Android = 'android',
  iOS = 'ios',
}

export enum OrderFulfillmentScope {
  Active = 'active',
  Cancelled = 'cancelled',
  Complete = 'complete',
}

export enum PushNotificationStatus {
  Granted = 'granted',
  Undetermined = 'undetermined',
  Denied = 'denied',
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export enum LoginBonusKind {
  MobileAppSignupBonus = 'mobile_app_signup_bonus',
}

export enum ProductAdditives {
  AcesulfamK = 'acesulfame_k',
  AceSucralose = 'ace_sucralose',
  Aesculin = 'aesculin',
  Agar = 'agar',
  Anthocyanin = 'anthocyanin',
  Antioxidant = 'antioxidant',
  AntioxidantAscorbicAcid = 'antioxidant_ascorbic_acid',
  AntioxidantTocopherols = 'antioxidant_tocopherols',
  Flavor = 'flavor',
  Flavors = 'flavors',
  AscorbicAcid = 'ascorbic_acid',
  Aspartame = 'aspartame',
  OysterSauce = 'oyster_sauce',
  BakingAid = 'baking_aid',
  BakingPowder = 'baking_powder',
  BalsamicVinegar = 'balsamic_vinegar',
  BalsamicCream = 'balsamic_cream',
  BasilPesto = 'basil_pesto',
  BenzoicAcid = 'benzoic_acid',
  BetaCarotene = 'beta_carotene',
  Betain = 'betain',
  BeetrootRed = 'beetroot_red',
  Beeswax = 'beeswax',
  Bitters = 'bitters',
  BlueCuracao = 'blue_curacao',
  BlueCuracaoSyrup = 'blue_curacao_syrup',
  BrandyVinegar = 'brandy_vinegar',
  Broth = 'broth',
  Caffeine = 'caffeine',
  Calcium = 'calcium',
  Caramel = 'caramel',
  CaramelColor = 'caramel_color',
  CaramelE150d = 'caramel_e150d',
  Carotene = 'carotene',
  CayennePepper = 'cayenne_pepper',
  Chili = 'chili',
  ChiliDressing = 'chili_dressing',
  ChiliMayonnaise = 'chili_mayonnaise',
  ChiliOil = 'chili_oil',
  Quinine = 'quinine',
  Chlorophyll = 'chlorophyll',
  CitricAcid = 'citric_acid',
  CitrusAcid = 'citrus_acid',
  CarbonDioxide = 'carbon_dioxide',
  CocktailSauce = 'cocktail_sauce',
  Curry = 'curry',
  CurryPaste = 'curry_paste',
  CurryPowder = 'curry_powder',
  CurryCreamSauce = 'curry_cream_sauce',
  Fragrance = 'fragrance',
}
